import { type IWidgetOption } from '../../../../Widget.ts';

/**
 * Ritorna tutti i valori ammessi per le opzioni di un widget di tipo scelta
 */
export function getOptionsPossibleValues(options: IWidgetOption[]) {
  const possibleOptionValues: string[] = [];
  options.forEach(option => {
    if (option.type === 'option') {
      possibleOptionValues.push(option.value.toString());
    }
  });

  return possibleOptionValues;
}
